import { hasOwn } from "@core/utility/utility";

export const measurable_parameter_name = (value) => {
  switch (value) {
    case "shipments":
      return "No. of Shipments";
    case "teu":
      return "TEU";
    case "weight":
      return "Weight";
    default:
      return "Shipment Value (USD)";
  }
};
export const main_dropdown_options = {
  entire_bill_of_lading: "All Categories",
  product_description: "Product",
  importers: "Consignee",
  exporters: "Shipper",
  product_hscode: "HS Code",
  chemical_description: "Chemical",
  ports: "Ports",
  logistics: "Logistics",
  product_category: "Product Category",
};
export const checkforFilters = (filterObj, appliedBooleanFilterObject) => {
  if (Object.keys(appliedBooleanFilterObject).length && hasOwn(appliedBooleanFilterObject, "include_master_bill") && !appliedBooleanFilterObject.include_master_bill) return true; // this is added to handle radio filter in us imports
  let flag = false;
  if (filterObj) {
    for (let key in filterObj) {
      if (filterObj[key].length !== 0) {
        flag = true;
        break;
      }
    }
  }
  return flag;
};
export const searchTypeCustomStyles = {
  control: (base, { isFocused }) => ({
    ...base,
    height: 44,
    minHeight: 44,
    backgroundColor: isFocused ? "#fff" : "#f9fafb",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#101828",
    border: isFocused ? "1px solid #6f08f1" : "1px solid #dddfe4",
    boxShadow: isFocused ? "0 0 0 2px #e4dbfa" : "none",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    fontWeight: 400,
    padding: "8px",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.14)" : isFocused ? "rgba(111, 8, 241, 0.1)" : null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    marginBottom: "8px",
  }),
};

export const WeightArray = {
  "0-1000": "upto 1,000 Kg",
  "1000-10000": "1,000-10,000 Kg",
  "10000-100000": "10,000-1,00,000 Kg",
  "100000-10000000": "1,00,000-1,00,00,000 Kg",
};
export const TeuArray = {
  "0-1": "Less than 1",
  "1-2": "Between 1 to 2",
  "2-3": "Between 2 to 3",
  "3-4": "Between 3 to 4",
  "4-200": "Above 4",
};

export const redirectionUrls = {
  us_imports: "search-shipments?comingFrom=Email&country=us-imports",
  us_exports: "us-exports-search?comingFrom=Email&country=us-exports",
  mx_exports: "mexico-search-export?comingFrom=Email&country=mx-exports",
  mx_imports: "mexico-search-import?comingFrom=Email&country=mx-imports",
  br_imports: "brazil-search-import-mirror?comingFrom=Email&country=br-imports",
  ar_exports: "argentina-search-export?comingFrom=Email&country=ar-exports",
  ar_imports: "argentina-search-import?comingFrom=Email&country=ar-imports",
  br_exports: "brazil-search-export-mirror?comingFrom=Email&country=br-exports",
  uy_exports: "uruguay-search-export?comingFrom=Email&country=uy-exports",
  uy_imports: "uruguay-search-import?comingFrom=Email&country=uy-imports",
  ec_imports: "ecuador-search-import?comingFrom=Email&country=ec-imports",
  ec_exports: "ecuador-search-export?comingFrom=Email&country=ec-exports",
  co_imports: "colombia-search-import?comingFrom=Email&country=co-imports",
  co_exports: "colombia-search-export?comingFrom=Email&country=co-exports",
  pr_exports: "peru-search-export?comingFrom=Email&country=pr-exports",
  pr_imports: "peru-search-import?comingFrom=Email&country=pr-imports",
  uk_imports: "uk-search-import?comingFrom=Email&country=uk-imports",
  uk_exports: "uk-search-export?comingFrom=Email&country=uk-exports",
  ch_imports: "chile-search-import?comingFrom=Email&country=ch-imports",
  ch_exports: "chile-search-export?comingFrom=Email&country=ch-exports",
  pa_imports: "panama-search-import?comingFrom=Email&country=pa-imports",
  pa_exports: "panama-search-export?comingFrom=Email&country=pa-exports",
  id_exports: "indonesia-search-export-mirror?comingFrom=Email&country=id-exports",
  id_imports: "indonesia-search-import-mirror?comingFrom=Email&country=id-imports",
  idnm_exports: "indonesia-search-export-nm?comingFrom=Email&country=idnm-exports",
  idnm_imports: "indonesia-search-import-nm?comingFrom=Email&country=idnm-imports",
  ph_exports: "philippines-search-export?comingFrom=Email&country=ph-exports",
  ph_imports: "philippines-search-import?comingFrom=Email&country=ph-imports",
  vn_exports: "vietnam-search-export?comingFrom=Email&country=vn-exports",
  vn_imports: "vietnam-search-import?comingFrom=Email&country=vn-imports",
  inmr3_exports: "india-search-export?comingFrom=Email&country=inmr3-exports",
  inmr3_imports: "india-search-import?comingFrom=Email&country=inmr3-imports",
  mc_imports: "all-country-shipments?comingFrom=Email&country=mc-imports",
  ru_imports: "russia-search-import-mirror?comingFrom=Email&country=ru-imports",
  ru_exports: "russia-search-export-mirror?comingFrom=Email&country=ru-exports",
  runm_imports: "russia-search-import?comingFrom=Email&country=runm-imports",
  runm_exports: "russia-search-export?comingFrom=Email&country=runm-exports",
  cn_imports: "china-search-import-mirror?comingFrom=Email&country=cn-imports",
  cn_exports: "china-search-export-mirror?comingFrom=Email&country=cn-exports",
  sg_imports: "singapore-search-import-mirror?comingFrom=Email&country=sg-imports",
  sg_exports: "singapore-search-export-mirror?comingFrom=Email&country=sg-exports",
  ae_imports: "uae-search-import-mirror?comingFrom=Email&country=ae-imports",
  ae_exports: "uae-search-export-mirror?comingFrom=Email&country=ae-exports",
  my_imports: "malaysia-search-import-mirror?comingFrom=Email&country=my-imports",
  my_exports: "malaysia-search-export-mirror?comingFrom=Email&country=my-exports",
  th_imports: "thailand-search-import-mirror?comingFrom=Email&country=th-imports",
  th_exports: "thailand-search-export-mirror?comingFrom=Email&country=th-exports",
  au_imports: "australia-search-import-mirror?comingFrom=Email&country=au-imports",
  au_exports: "australia-search-export-mirror?comingFrom=Email&country=au-exports",
  middleeast_imports: "middle-east-search-import-mirror?comingFrom=Email&country=middleeast-imports",
  middleeast_exports: "middle-east-search-export-mirror?comingFrom=Email&country=middleeast-exports",
  eu_imports: "europe-search-import-mirror?comingFrom=Email&country=eu-imports",
  eu_exports: "europe-search-export-mirror?comingFrom=Email&country=eu-exports",
  tw_imports: "taiwan-search-import-mirror?comingFrom=Email&country=tw-imports",
  tw_exports: "taiwan-search-export-mirror?comingFrom=Email&country=tw-exports",
  sa_imports: "saudi-arabia-search-import-mirror?comingFrom=Email&country=sa-imports",
  sa_exports: "saudi-arabia-search-export-mirror?comingFrom=Email&country=sa-exports",
  ca_imports: "canada-search-import-mirror?comingFrom=Email&country=ca-imports",
  ca_exports: "canada-search-export-mirror?comingFrom=Email&country=ca-exports",
  de_imports: "germany-search-import-mirror?comingFrom=Email&country=de-imports",
  de_exports: "germany-search-export-mirror?comingFrom=Email&country=de-exports",
  hk_imports: "hong-kong-search-import-mirror?comingFrom=Email&country=hk-imports",
  hk_exports: "hong-kong-search-export-mirror?comingFrom=Email&country=hk-exports",
  jp_imports: "japan-search-import-mirror?comingFrom=Email&country=jp-imports",
  jp_exports: "japan-search-export-mirror?comingFrom=Email&country=jp-exports",
  kr_imports: "south-korea-search-import-mirror?comingFrom=Email&country=kr-imports",
  kr_exports: "south-korea-search-export-mirror?comingFrom=Email&country=kr-exports",
  global_imports: "global-search?comingFrom=Email&country=global data",
  bw_imports: "botswana-search-import?comingFrom=Email&country=bw-imports",
  bw_exports: "botswana-search-export?comingFrom=Email&country=bw-exports",
  gh_imports: "ghana-search-import?comingFrom=Email&country=gh-imports",
  gh_exports: "ghana-search-export?comingFrom=Email&country=gh-exports",
  ls_imports: "lesotho-search-import?comingFrom=Email&country=ls-imports",
  ls_exports: "lesotho-search-export?comingFrom=Email&country=ls-exports",
  pk_imports: "pakistan-search-import?comingFrom=Email&country=pk-imports",
  pk_exports: "pakistan-search-export?comingFrom=Email&country=pk-exports",
  ss_imports: "sudan-search-import?comingFrom=Email&country=ss-imports",
  ci_imports: "ivory-coast-search-import?comingFrom=Email&country=ci-imports",
  ci_exports: "ivory-coast-search-export?comingFrom=Email&country=ci-exports",
  rw_imports: "rawandi-search-import?comingFrom=Email&country=rw-imports",
  na_imports: "namibia-search-import?comingFrom=Email&country=na-imports",
  na_exports: "namibia-search-export?comingFrom=Email&country=na-exports",
  ke_imports: "kenya-search-import?comingFrom=Email&country=ke-imports",
  cm_imports: "cameroon-search-import?comingFrom=Email&country=cm-imports",
  cm_exports: "cameroon-search-export?comingFrom=Email&country=cm-exports",
  bd_imports: "bangladesh-search-import?comingFrom=Email&country=bd-imports",
  bd_exports: "bangladesh-search-export?comingFrom=Email&country=bd-exports",
  ng_imports: "nigeria-search-import?comingFrom=Email&country=ng-imports",
  ng_exports: "nigeria-search-export?comingFrom=Email&country=ng-exports",
  tr_imports: "turkey-search-import-mirror?comingFrom=Email&country=tr-imports",
  tr_exports: "turkey-search-export-mirror?comingFrom=Email&country=tr-exports",
  st_imports: "sao-tome-search-import?comingFrom=Email&country=st-imports",
  st_exports: "sao-tome-search-export?comingFrom=Email&country=st-exports",
  kz_imports: "kazakhstan-search-import?comingFrom=Email&country=kz-imports",
  kz_exports: "kazakhstan-search-export?comingFrom=Email&country=kz-exports",
  uz_imports: "uzbekistan-search-import?comingFrom=Email&country=uz-imports",
  uz_exports: "uzbekistan-search-export?comingFrom=Email&country=uz-exports",
  lk_imports: "srilanka-search-import?comingFrom=Email&country=lk-imports",
  lk_exports: "srilanka-search-export?comingFrom=Email&country=lk-exports",
  py_imports: "paraguay-search-import?comingFrom=Email&country=py_imports",
  py_exports: "paraguay-search-export?comingFrom=Email&country=py_exports",
  cr_imports: "costa-rica-search-import?comingFrom=Email&country=cr-imports",
  cr_exports: "costa-rica-search-export?comingFrom=Email&country=cr-exports",
  et_imports: "ethiopia-search-import?comingFrom=Email&country=et-imports",
  et_exports: "ethiopia-search-export?comingFrom=Email&country=et-exports",
  ug_imports: "uganda-search-import?comingFrom=Email&country=ug-imports",
  ug_exports: "uganda-search-export?comingFrom=Email&country=ug-exports",
  usm_imports: "search-shipments?comingFrom=Email&country=usm-imports",
  usm_exports: "us-exports-search?comingFrom=Email&country=usm-exports",
  mxm_imports: "mx-search-import-maritime?comingFrom=Email&country=mxm-imports",
  mxm_exports: "mx-search-export-maritime?comingFrom=Email&country=mxm-exports",
};
